/**
 * Every term whose DEFAULT follows the account's region, in one call: the
 * pay-cycle terms (PAY-3372) and the docket terms (PAY-4262). A terminology
 * merge puts this UNDER the account's own terminology, never over it.
 *
 * Callers use this rather than each table, so a term that starts varying by
 * region reaches every merge (web messages, report jobs, Milo) at once.
 */
import type { AccountRegion } from './currency';
import { regionDocketTerms } from './docket-terms';
import { regionPayCycleTerms } from './pay-cycle-terms';

/**
 * @param region - the PARSED region (`parseRegionSetting` of the stored
 *   setting). Parse at the boundary where the setting is read, not here.
 */
export function regionTermDefaults(
  region: AccountRegion | null,
): Record<string, string> {
  return {
    ...regionPayCycleTerms(region),
    ...regionDocketTerms(region),
  } as Record<string, string>;
}
